import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { isLoginAuth } from "utils/login";

const Login = () => {
  let navigate = useNavigate();
  useEffect(() => {
    const hfnAuthInfo = localStorage.getItem("hfnAuthInfo");
    if (!isLoginAuth() && !hfnAuthInfo) {
      const oneAuthElement = document.querySelector("hfn-auth");

      if (oneAuthElement?.triggerAuth) {
        oneAuthElement.triggerAuth();
      }
    } else if (isLoginAuth()) {
      navigate("/");
    } else {
      navigate("/select-role");
    }
  }, []);

  return (
    <div className="login-section">
      <div />
    </div>
  );
};

export default Login;
